// extracted by mini-css-extract-plugin
export default {"modal":"ModalTutorial_modal__OnHje","closeIcon":"ModalTutorial_closeIcon__Ohwfr","text":"ModalTutorial_text__ADVkn","imagen":"ModalTutorial_imagen__51pWp"};